export default __webpack_public_path__ + "static/media/Ambient, Green.de928065.png";